export const formatCost = (value?: number | null) =>
  value
    ? Intl.NumberFormat('en', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value)
    : 0

export const formatMinutes = (value?: number | null) =>
  value
    ? Intl.NumberFormat('en', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value)
    : 0
